module.exports = __webpack_public_path__ + "img/p3_l.9f1d7095.jpg";